import * as React from 'react';
import Collections from '@ui/scenes/Collections';

const CollectionsPage = () => <Collections />;

export default CollectionsPage;



// WEBPACK FOOTER //
// ./src/pages/Collections/Collections.tsx